import styled from "styled-components";

import { Body } from "../../../../design-system/typography";

export const Container = styled(Body).attrs({ as: "div" })`
  .complex & {
    margin-bottom: 1em;
  }
`;

export const InitialContentWrapper = styled.div`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
`;

export const FullContentWrapper = styled.div`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
`;

export const ButtonWrapper = styled.div`
  margin-top: 16px;
`;
